// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-heading {
  color: var(--primary-color);
  font-weight: 700;
  font-size: 22px;
  line-height: 28px;
  margin-bottom: 10px;
}

.title {
  color: var(--primary-font-color);
  font-weight: 500;
  line-height: 38px;
  font-size: 30px;
  margin-bottom: 5px;
}

.sub-title {
  color: var(--secondary-grey-color);
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 8px;
}

.form {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
}
.form .login-form-field {
  width: 100%;
  margin-bottom: 16px;
}
.form .element-title {
  color: var(--dark-grey-font);
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 7px;
}
.form .password-visibility {
  cursor: pointer;
  font-size: 18px;
  height: 18px;
  width: 18px;
  line-height: 18px;
  color: var(--secondary-grey-color);
  display: flex;
  align-items: center;
  justify-content: center;
  padding-inline-end: 12px;
}
.form .captcha-container {
  margin: 28px 0 20px;
}
.form .form-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 3px 0 12px 0;
}
.form .form-actions .link {
  color: var(--link-color);
  line-height: 20px;
  font-size: 12px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
}
.form button {
  width: 100%;
  border-radius: 10px !important;
}

.spinner {
  width: 12px;
  height: 12px;
  border: 2px solid var(--spinner-border-color);
  border-top-color: var(--spinner-border-top-color);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.register {
  margin-top: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.register .text {
  color: var(--secondary-grey-color);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}
.register .link {
  color: var(--link-color);
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
}

@media (max-width: 767px) {
  .page-heading {
    font-size: 20px;
    line-height: 26px;
  }
  .title {
    font-size: 26px;
    line-height: 34px;
  }
  .sub-title {
    font-size: 15px;
    line-height: 22px;
  }
  .form {
    margin-top: 16px;
  }
  .form .login-form-field {
    margin-bottom: 10px;
  }
  .form .element-title {
    font-size: 13px;
    margin-bottom: 6px;
  }
}
@media (max-width: 479px) {
  .page-heading {
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 8px;
  }
  .title {
    font-size: 22px;
    line-height: 30px;
    margin-bottom: 4px;
  }
  .sub-title {
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 6px;
  }
  .form {
    margin-top: 12px;
  }
  .form .login-form-field {
    margin-bottom: 12px;
  }
  .form .element-title {
    font-size: 12.5px;
    line-height: 18px;
    margin-bottom: 6px;
  }
  .form .password-visibility {
    padding-inline-end: 10px;
  }
  .form .form-actions {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
  .form .form-actions .link {
    font-size: 12px;
    align-self: flex-end;
  }
  .form button {
    border-radius: 8px !important;
  }
  .register {
    flex-direction: column;
    gap: 6px;
    margin-top: 12px;
  }
  .register .text,
  .register .link {
    font-size: 13px;
    line-height: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/login/login.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AADD;;AAIA;EACC,gCAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AADD;;AAIA;EACC,kCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AADD;;AAIA;EACC,aAAA;EACA,sBAAA;EACA,gBAAA;AADD;AAGC;EACC,WAAA;EACA,mBAAA;AADF;AAIC;EACC,4BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAFF;AAKC;EACC,eAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;AAHF;AAMC;EACC,mBAAA;AAJF;AAOC;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;AALF;AAOE;EACC,wBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;AALH;AASC;EACC,WAAA;EACA,8BAAA;AAPF;;AAWA;EACC,WAAA;EACA,YAAA;EACA,6CAAA;EACA,iDAAA;EACA,kBAAA;EACA,oCAAA;AARD;;AAWA;EACC;IACC,yBAAA;EARA;AACF;AAWA;EACC,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AATD;AAWC;EACC,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AATF;AAYC;EACC,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AAVF;;ACkCQ;EDlBP;IACC,eAAA;IACA,iBAAA;EAZA;EAeD;IACC,eAAA;IACA,iBAAA;EAbA;EAgBD;IACC,eAAA;IACA,iBAAA;EAdA;EAiBD;IACC,gBAAA;EAfA;EAiBA;IACC,mBAAA;EAfD;EAkBA;IACC,eAAA;IACA,kBAAA;EAhBD;AACF;ACSQ;EDaP;IACC,eAAA;IACA,iBAAA;IACA,kBAAA;EAnBA;EAsBD;IACC,eAAA;IACA,iBAAA;IACA,kBAAA;EApBA;EAuBD;IACC,eAAA;IACA,iBAAA;IACA,kBAAA;EArBA;EAwBD;IACC,gBAAA;EAtBA;EAwBA;IACC,mBAAA;EAtBD;EAyBA;IACC,iBAAA;IACA,iBAAA;IACA,kBAAA;EAvBD;EA0BA;IACC,wBAAA;EAxBD;EA2BA;IACC,sBAAA;IACA,oBAAA;IACA,SAAA;EAzBD;EA2BC;IACC,eAAA;IACA,oBAAA;EAzBF;EA6BA;IACC,6BAAA;EA3BD;EA+BD;IACC,sBAAA;IACA,QAAA;IACA,gBAAA;EA7BA;EA+BA;;IAEC,eAAA;IACA,iBAAA;EA7BD;AACF","sourcesContent":["@import \"src/theme/mixins.scss\";\n\n.page-heading {\n\tcolor: var(--primary-color);\n\tfont-weight: 700;\n\tfont-size: 22px;\n\tline-height: 28px;\n\tmargin-bottom: 10px;\n}\n\n.title {\n\tcolor: var(--primary-font-color);\n\tfont-weight: 500;\n\tline-height: 38px;\n\tfont-size: 30px;\n\tmargin-bottom: 5px;\n}\n\n.sub-title {\n\tcolor: var(--secondary-grey-color);\n\tfont-weight: 400;\n\tfont-size: 16px;\n\tline-height: 24px;\n\tmargin-bottom: 8px;\n}\n\n.form {\n\tdisplay: flex;\n\tflex-direction: column;\n\tmargin-top: 20px;\n\n\t.login-form-field {\n\t\twidth: 100%;\n\t\tmargin-bottom: 16px;\n\t}\n\n\t.element-title {\n\t\tcolor: var(--dark-grey-font);\n\t\tfont-weight: 500;\n\t\tfont-size: 14px;\n\t\tline-height: 20px;\n\t\tmargin-bottom: 7px;\n\t}\n\n\t.password-visibility {\n\t\tcursor: pointer;\n\t\tfont-size: 18px;\n\t\theight: 18px;\n\t\twidth: 18px;\n\t\tline-height: 18px;\n\t\tcolor: var(--secondary-grey-color);\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tpadding-inline-end: 12px;\n\t}\n\n\t.captcha-container {\n\t\tmargin: 28px 0 20px;\n\t}\n\n\t.form-actions {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\tmargin: 3px 0 12px 0;\n\n\t\t.link {\n\t\t\tcolor: var(--link-color);\n\t\t\tline-height: 20px;\n\t\t\tfont-size: 12px;\n\t\t\tfont-weight: 500;\n\t\t\ttext-decoration: none;\n\t\t\tcursor: pointer;\n\t\t}\n\t}\n\n\tbutton {\n\t\twidth: 100%;\n\t\tborder-radius: 10px !important;\n\t}\n}\n\n.spinner {\n\twidth: 12px;\n\theight: 12px;\n\tborder: 2px solid var(--spinner-border-color);\n\tborder-top-color: var(--spinner-border-top-color);\n\tborder-radius: 50%;\n\tanimation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n\tto {\n\t\ttransform: rotate(360deg);\n\t}\n}\n\n.register {\n\tmargin-top: 14px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tgap: 10px;\n\n\t.text {\n\t\tcolor: var(--secondary-grey-color);\n\t\tfont-size: 14px;\n\t\tfont-weight: 400;\n\t\tline-height: 20px;\n\t}\n\n\t.link {\n\t\tcolor: var(--link-color);\n\t\tfont-weight: 600;\n\t\tfont-size: 14px;\n\t\tline-height: 20px;\n\t\tcursor: pointer;\n\t}\n}\n\n// ---------- Tablet (below md) ----------\n@include respond-below(md) {\n\t.page-heading {\n\t\tfont-size: 20px;\n\t\tline-height: 26px;\n\t}\n\n\t.title {\n\t\tfont-size: 26px;\n\t\tline-height: 34px;\n\t}\n\n\t.sub-title {\n\t\tfont-size: 15px;\n\t\tline-height: 22px;\n\t}\n\n\t.form {\n\t\tmargin-top: 16px;\n\n\t\t.login-form-field {\n\t\t\tmargin-bottom: 10px;\n\t\t}\n\n\t\t.element-title {\n\t\t\tfont-size: 13px;\n\t\t\tmargin-bottom: 6px;\n\t\t}\n\t}\n}\n\n// ---------- Mobile (below xs) ----------\n@include respond-below(xs) {\n\t.page-heading {\n\t\tfont-size: 18px;\n\t\tline-height: 24px;\n\t\tmargin-bottom: 8px;\n\t}\n\n\t.title {\n\t\tfont-size: 22px;\n\t\tline-height: 30px;\n\t\tmargin-bottom: 4px;\n\t}\n\n\t.sub-title {\n\t\tfont-size: 14px;\n\t\tline-height: 20px;\n\t\tmargin-bottom: 6px;\n\t}\n\n\t.form {\n\t\tmargin-top: 12px;\n\n\t\t.login-form-field {\n\t\t\tmargin-bottom: 12px;\n\t\t}\n\n\t\t.element-title {\n\t\t\tfont-size: 12.5px;\n\t\t\tline-height: 18px;\n\t\t\tmargin-bottom: 6px;\n\t\t}\n\n\t\t.password-visibility {\n\t\t\tpadding-inline-end: 10px;\n\t\t}\n\n\t\t.form-actions {\n\t\t\tflex-direction: column;\n\t\t\talign-items: stretch;\n\t\t\tgap: 10px;\n\n\t\t\t.link {\n\t\t\t\tfont-size: 12px;\n\t\t\t\talign-self: flex-end;\n\t\t\t}\n\t\t}\n\n\t\tbutton {\n\t\t\tborder-radius: 8px !important;\n\t\t}\n\t}\n\n\t.register {\n\t\tflex-direction: column;\n\t\tgap: 6px;\n\t\tmargin-top: 12px;\n\n\t\t.text,\n\t\t.link {\n\t\t\tfont-size: 13px;\n\t\t\tline-height: 18px;\n\t\t}\n\t}\n}\n","// custom fons facemizxin\n\n@mixin font-face($font-family, $url) {\n    @font-face {\n        font-family: '#{$font-family}';\n        src: url('#{$url}.eot');\n        src: url('#{$url}.eot?#iefix') format('embedded-opentype'),\n        url('#{$url}.woff') format('woff'),\n        url('#{$url}.ttf') format('truetype'),\n        url('#{$url}.svg') format('svg');\n        font-weight: normal;\n        font-style: normal;\n    }\n}\n\n\n\n//custom font resposnive muin\n$font-base-min: 14px;\n$font-base-max: 6;\n$breakmin: 320px;\n$breakmax: 768px;\n$customSize: 5px;\n\n@mixin font-responsive($fmin, $fdiff, $breakmin, $breakdiff) {\n    font-size: calc(#{$fmin} + #{$fdiff} * ((100vw - #{$breakmin}) / #{$breakdiff}));\n\n    @media(max-width: $breakmin) {\n        font-size: $fmin;\n    }\n\n    @media(min-width: round($breakmin + $breakmax)) {\n        font-size: round($fmin + $fdiff);\n    }\n\n    @media(max-width: $breakmax) {\n        // font-size: round($fmin + 3px);\n        font-size: calc(#{$fmin} + #{$customSize});\n    }\n}\n\n\n// custom font source mmixins\n\n@mixin font($colour: false, $weight: false, $lh: false, $spacing: false) {\n\n    // @if $size { font-size: $size; }\n    @if $colour {\n        color: $colour;\n    }\n\n    @if $weight {\n        font-weight: $weight;\n    }\n\n    @if $lh {\n        line-height: $lh;\n    }\n\n    @if $spacing {\n        letter-spacing: $spacing;\n    }\n}\n\n\n// custom input placeholder mixins\n\n@mixin input-placeholder {\n    &.placeholder {\n        @content;\n    }\n\n    &:-moz-placeholder {\n        @content;\n    }\n\n    &::-moz-placeholder {\n        @content;\n    }\n\n    &:-ms-input-placeholder {\n        @content;\n    }\n\n    &::-webkit-input-placeholder {\n        @content;\n    }\n}\n\n\n// A map of breakpoints.\n$breakpoints: (\n    xs: 480px,\n    sm: 576px,\n    md: 768px,\n    lg: 992px,\n    xl: 1200px,\n    xxl: 1600px,\n    ipadSize: 768px,\n    ipadmin:481px,\n    ipadmax:1024px,\n    ipadlandscape:1320px,\n\n);\n\n// Respond above.\n@mixin respond-above($breakpoint) {\n\n    // If the breakpoint exists in the map.\n    @if map-has-key($breakpoints, $breakpoint) {\n\n        // Get the breakpoint value.\n        $breakpoint-value: map-get($breakpoints, $breakpoint);\n\n        // Write the media query.\n        @media (min-width: $breakpoint-value) {\n            @content;\n        }\n\n        // If the breakpoint doesn't exist in the map.\n    }\n\n    @else {\n\n        // Log a warning.\n        @warn 'Invalid breakpoint: #{$breakpoint}.';\n    }\n}\n\n\n\n\n@mixin respond-below($breakpoint) {\n\n    // If the breakpoint exists in the map.\n    @if map-has-key($breakpoints, $breakpoint) {\n\n        // Get the breakpoint value.\n        $breakpoint-value: map-get($breakpoints, $breakpoint);\n\n        // Write the media query.\n        @media (max-width: ($breakpoint-value - 1)) {\n            @content;\n        }\n\n        // If the breakpoint doesn't exist in the map.\n    }\n\n    @else {\n\n        // Log a warning.\n        @warn 'Invalid breakpoint: #{$breakpoint}.';\n    }\n}\n\n\n\n@mixin respond-between($lower, $upper) {\n\n    // If both the lower and upper breakpoints exist in the map.\n    @if map-has-key($breakpoints, $lower) and map-has-key($breakpoints, $upper) {\n\n        // Get the lower and upper breakpoints.\n        $lower-breakpoint: map-get($breakpoints, $lower);\n        $upper-breakpoint: map-get($breakpoints, $upper);\n\n        // Write the media query.\n        @media (min-width: $lower-breakpoint) and (max-width: ($upper-breakpoint - 1)) {\n            @content;\n        }\n\n        // If one or both of the breakpoints don't exist.\n    }\n\n    @else {\n\n        // If lower breakpoint is invalid.\n        @if (map-has-key($breakpoints, $lower)==false) {\n\n            // Log a warning.\n            @warn 'Your lower breakpoint was invalid: #{$lower}.';\n        }\n\n        // If upper breakpoint is invalid.\n        @if (map-has-key($breakpoints, $upper)==false) {\n\n            // Log a warning.\n            @warn 'Your upper breakpoint was invalid: #{$upper}.';\n        }\n    }\n}\n\n\n// @media only screen and (device-width: 768px) {}\n\n// @media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation:portrait) {}\n\n// @media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation:landscape) {\n//     /* For landscape layouts only */\n// }\n\n/// vernodr prefixes\n\n@mixin css3-prefix($prop, $value) {\n    -webkit-#{$prop}: #{$value};\n    -moz-#{$prop}: #{$value};\n    -ms-#{$prop}: #{$value};\n    -o-#{$prop}: #{$value};\n    #{$prop}: #{$value};\n}\n\n\n//  vertical cneter\n@mixin vertical-center {\n    position: relative;\n    top: 50%;\n    -ms-transform: translateY(-50%);\n    -webkit-transform: translateY(-50%);\n    transform: translateY(-50%);\n}\n\n//keyframe miins\n\n@mixin keyframes($name) {\n    @-webkit-keyframes #{$name} {\n        @content;\n    }\n\n    @-moz-keyframes #{$name} {\n        @content;\n    }\n\n    @keyframes #{$name} {\n        @content;\n    }\n}\n\n//absolute positoning\n\n@mixin abs-position ($top, $right, $bottom, $left) {\n    position: absolute;\n    top: $top;\n    right: $right;\n    bottom: $bottom;\n    left: $left;\n}\n\n\n//arrow minis\n@mixin arrow($direction: down, $size: 5px, $color: #555) {\n    width: 0;\n    height: 0;\n\n    @if ($direction ==left) {\n        border-top: $size solid transparent;\n        border-bottom: $size solid transparent;\n        border-right: $size solid $color;\n    }\n\n    @else if ($direction ==right) {\n        border-top: $size solid transparent;\n        border-bottom: $size solid transparent;\n        border-left: $size solid $color;\n    }\n\n    @else if ($direction ==down) {\n        border-left: $size solid transparent;\n        border-right: $size solid transparent;\n        border-top: $size solid $color;\n    }\n\n    @else {\n        border-left: $size solid transparent;\n        border-right: $size solid transparent;\n        border-bottom: $size solid $color;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
